"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _BadgeList = _interopRequireDefault(require("../../BadgeList"));
var _context = require("../context");
var _ItineraryBadgeListItem = _interopRequireDefault(require("./ItineraryBadgeListItem"));
exports.ItineraryBadgeListItem = _ItineraryBadgeListItem.default;
var _tailwind = require("../../common/tailwind");
var _useTheme = _interopRequireDefault(require("../../hooks/useTheme"));
const ItineraryBadgeList = ({
  children,
  spaceAfter,
  ...props
}) => {
  const {
    itinerarySegmentMinimalColumnWidth: offset
  } = (0, _context.useItinerarySegmentMinimalColumnWidth)();
  const theme = (0, _useTheme.default)();
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)("orbit-itinerary-badge-list", spaceAfter && _tailwind.spaceAfterClasses[spaceAfter]),
    style: {
      marginInlineStart: `${2 * parseInt(theme.orbit.space300, 10) + offset}px`
    }
  }, /*#__PURE__*/React.createElement(_BadgeList.default, props, children));
};
var _default = exports.default = ItineraryBadgeList;